import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter, map} from 'rxjs';
import {environment} from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    applicationName: string = environment.appName;
    appNameShort = environment.appNameShort;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private titleService: Title) {

        // Mise à jour du titre de la page en fonction de la route active
        this.router.events.pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let child = this.activatedRoute.firstChild;
                    while (child) {
                        if (child.firstChild) {
                            child = child.firstChild;
                        } else if (child.snapshot.data && child.snapshot.data['title']) {
                            return child.snapshot.data['title'];
                        } else {
                            return null;
                        }
                    }
                    return null;
                })
        ).subscribe((data: any) => {
            if (data) {
                data = data === '' ? '' : (data + ' - ');
                this.titleService.setTitle( data + this.appNameShort);
            }
        });
    }

}

